"use strict";
import { COLORS } from "./chartColors";
export const applicationCountSourceTypeTransformer = (data) => {
  const sourceTypes = {};
  Object.entries(data).forEach(([key, value]) => {
    if (!value.data.reportNotFound) {
      value.data.forEach((record) => {
        sourceTypes[record.source_type] = (sourceTypes[record.source_type] || 0) + 1;
      });
    }
  });
  return {
    labels: Object.keys(sourceTypes),
    datasets: [
      {
        data: Object.values(sourceTypes),
        borderWidth: 1,
        backgroundColor: COLORS.slice(0, Object.keys(sourceTypes).length)
      }
    ]
  };
};
